
import { Options, Vue } from 'vue-class-component';
import { EstimationClient, BagEstimationClient } from '@/services/Services';
import { baseUrl } from '@/config';
import BestBagCombinationTable from '../components/bestBagCombinationTable.vue';
import SuggestionFiltersModal from '../modals/suggestionFiltersModal.vue';
import filters from '@/filters';
import * as OM from '@/Model';

@Options({
    components: {
        BestBagCombinationTable
    }
})
export default class BestBagCombination extends Vue {

    estimationIdentifier: string = "";
    originalEstimation: OM.BestBagCombination = new OM.BestBagCombination();
    bestCombinationRis: OM.BestBagCombinationResultsVM = new OM.BestBagCombinationResultsVM();

    filters: OM.BestCombinationFilters = new OM.BestCombinationFilters();

    created() {
        this.estimationIdentifier = this.$route.params.estimationIdentifier.toString();
        this.filters.estimationIdentifier = this.estimationIdentifier;
        this.filters.indexForMaterials = 0;
        this.filters.indexForCountries = 0;

        this.init();
    }

    init() {
        Promise.all([
            BagEstimationClient.getBagEstimationData(this.estimationIdentifier),
            EstimationClient.bestBagCo2EmissionsConfigurationByGarment(this.filters)
        ])
        .then(xs => {
            this.originalEstimation = xs[0];
            this.bestCombinationRis = xs[1];
        })
    }

    get bestCombination() {
        return this.bestCombinationRis.bestBagCombination;
    }

    prevComb() {
        if(this.filters.indexForMaterials == 0 && this.filters.indexForCountries == 0)
            return;

        if(this.filters.indexForCountries == 0)
            this.filters.indexForMaterials--;
        else
            this.filters.indexForCountries--;

        this.init();
    }
    nextComb() {
        if(!this.bestCombinationRis.hasMoreMaterialCombinations && !this.bestCombinationRis.hasMoreCountryCombinations)
            return;

        if(!this.bestCombinationRis.hasMoreMaterialCombinations)
            this.filters.indexForCountries++;
        else
            this.filters.indexForMaterials++;

        this.init();
    }

    openFilters() {
        this.$opModal.show(SuggestionFiltersModal, {
            garmentIdentifier: this.originalEstimation.bestBagEstimation.bagData.garment.identifier,
            activeFilters: this.filters,
            showGSMSuggestion: false,
            callback: (keepUsingEstimationRawMaterialsString: string, useProvidersString: string, keepUsingEstimationGSMString: string) => {
                this.filters.keepUsingOriginalEstimationRawMaterials = keepUsingEstimationRawMaterialsString == true.toString();
                this.filters.useUserProviders = useProvidersString == true.toString();
                this.filters.useSameGrams = keepUsingEstimationGSMString == true.toString();

                this.$opModal.closeLast();
                this.init();
            }
        })
    }

    downloadBestCombinationPDF() {
        var actualDate = filters.date(new Date(), "dd-MM-YYYY", false);
        var fileName = "best_combination_" + this.bestCombination.bestBagEstimation.sku + "_" + actualDate;
        this.$utils.downloadBestCombinationPdf(baseUrl + "api/Estimation/DownloadBestBagCombinationPDF", this.bestCombination.identifier, fileName);
    }

}
